import { TaskKind } from "@/generated/graphql";

/** The parts of a copy's answer that decide where the teacher goes next. */
interface CopyResult {
  task: { id: string; kind: TaskKind };
  assessmentSettings: { vivaSourceTask: { id: string } | null };
}

/**
 * The path to open after a copy, built from what the copy itself reports.
 *
 * A reused sheet sets the destination's preset, so the task the content lands
 * in is not always the task the teacher started from. 
 */
export function copyLandingPath(basePath: string, copy: CopyResult): string {
  const { task, assessmentSettings } = copy;

  if (task.kind === TaskKind.Viva && assessmentSettings.vivaSourceTask == null) {
    return `${basePath}/settings/link-viva-assessment`;
  }

  return `${basePath}/task/${task.id}/edit`;
}
